angular.module('rings-app.home', ['rings-app.grandfather'])
.config(function ($stateProvider,$urlRouterProvider) {
  $stateProvider
    .state('app.home', {
      url: '/',
      templateUrl: 'home/home.tpl.html',
      accessLevel: accessLevels.public,
    });
})